import ServicePlanSubscriptionsPageContent from 'components/service-plan-subscriptions';

export default function ServicePlans() {
  return <ServicePlanSubscriptionsPageContent />;
}
